import axios from 'axios'
import { useUserStore } from "@/store/modules/user";
import router from "@/router/index"
import {ElMessage} from "element-plus";
// 创建axios实例
const apiUrl = process.env.VUE_APP_API_URL;
const service = axios.create({
  baseURL: apiUrl, // 接口baseURL
  timeout: 60000, // 请求超时时间
  headers: {},
  params: {},
  data: {},
  withCredentials: true,
})
// 请求拦截器
service.interceptors.request.use(
  // 请求配置
  (config) => {
    const userStore = useUserStore()
    const tokenValue = userStore.token;
    const tokenName = 'Authorization';
    config.headers[tokenName] = tokenValue;
    return config

  },
  // 请求错误
  (error) => {
    if (import.meta.env.DEV) {
      console.log('request', error)
    }
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  /**
   * 通过接口返回码确定返回状态
   * 还可以通过HTTP状态代码来判断请求状态
   */
  (response) => {
    // 响应数据
    const res = response.data
    if (response.data instanceof Blob) {
      // 文件下载
      if (response.data.type == 'application/json') {
        const reader = new FileReader()
        reader.onload = function (event) {
          const jsonString = event.target.result
          const jsonObject = JSON.parse(jsonString)
          responseHandle(jsonObject)
        }
        reader.readAsText(response.data)
      } else {
        const file_name = response.config.params?.file_name || ''
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(response.data)
        if (file_name) {
          link.setAttribute('download', file_name)
        }
        document.body.appendChild(link)
        link.click()
        link.remove()
      }
    } else {
      // 返回码200：成功
      if (response.status === 200 && (res.code == 1 || res.code == 0)) {
        return res
      } else {
        responseHandle(res)
      }
    }
  },
  (error) => {
    // 响应错误
    if (error.response) {
      const res = error.response.data
      //responseHandle(res)
      if (import.meta.env.DEV) {
        console.log('response', error)
      }
    } else {
      return Promise.reject(error)
    }
  }
)

// 响应处理
function responseHandle(res) {
  console.log(res);
  if (res.code === 401) {
    const userStore = useUserStore();
    // 清除 token
    userStore.resetToken();
    // 跳转到登录页面
    router.push('/login')

    ElMessage({
      message: '登录过期请重新登录',
      grouping: true,
      type:'error',
    })
  }
  // 其他情况直接返回 res（不弹窗）
  return res;
}

export default service
